/**
 * @desc 定制提示性modal组件；
 */

import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Modal, Space, Button, Spin } from 'antd';
import './style';

// interface SimpleModalProps {
//   visible: boolean;
//   onCancel?: () => void;
//   modalText?: JSX.Element | string;
//   tips?: JSX.Element | string;
//   btnGap?: number;
//   onOk?: () => void;
//   footer?: React.ReactChild;
// }

// export interface SimpleModalInstance {
//   setSpinning: (spinning: boolean) => void;
// }

const SimpleModal = (
  props,
  ref,
) => {
  const { visible, onCancel, modalText, onOk, footer, tips, wrapperClassName, btnGap, centered = true } = props;
  const [spinning, setSpinning] = useState(false);
  const wrapperCls = wrapperClassName
    ? `simple-modal-wrap ${wrapperClassName}`
    : 'simple-modal-wrap';

  /**
   * 向外暴露的实例方法
   */
  useImperativeHandle(ref, () => {
    return {
      setSpinning: (spinning) => {
        setSpinning(spinning);
      },
    };
  });

  useEffect(() => {
    if (!visible && setSpinning) {
      setSpinning(false);
    }
  }, [visible]);
  return (
    <Modal
      title={null}
      footer={null}
      closeIcon={<></>}
      open={visible}
      centered={centered}
      wrapClassName={wrapperCls}
    >
      <Spin spinning={spinning}>
        <div className="modal-content">
          <div className="content-box">
            <div className="content-title">
              <span className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  style={{
                    width: '18px',
                    height: '18px',
                    verticalAlign: 'text-bottom',
                    transform: 'rotate(180deg)',
                  }}
                  viewBox="0 0 1024 1024"
                >
                  <circle cx="512" cy="512" r="512" fill="#FF8000"></circle>
                  <path
                    d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                    fill="white"
                  ></path>
                </svg>
              </span>
              <span className="text">{modalText}</span>
            </div>
            {tips && <div className="content-tips">{tips}</div>}
          </div>
        </div>
        {!footer && (
          <div className="footer">
            <Space size={btnGap}>
              <Button
                onClick={() => {
                  onCancel?.();
                }}
                className="cancel-btn"
              >
                取消
              </Button>
              <Button
                className="confirm-btn"
                onClick={() => {
                  setSpinning(true);
                  onOk?.();
                }}
              >
                确定
              </Button>
            </Space>
          </div>
        )}
        {footer}
      </Spin>
    </Modal>
  );
};

export default React.forwardRef(SimpleModal);
